function formatCurrency(value: any) {
  return `CHF ${value}`;
}

export default formatCurrency;
